(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3058],{

/***/ 17812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1591);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41810);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93871);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, color !== 'default' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.label
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),

/***/ 64489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ bit; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(91315);
// EXTERNAL MODULE: ./common/MediaQueries.tsx
var MediaQueries = __webpack_require__(1438);
// EXTERNAL MODULE: ./components/PurchasePage/PurchaseContext.tsx
var PurchaseContext = __webpack_require__(33574);
// EXTERNAL MODULE: ./components/Reusable/Loader.tsx
var Loader = __webpack_require__(83457);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/pages/payment.tsx + 2 modules
var payment = __webpack_require__(43050);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/PaymentContext.tsx
var PaymentContext = __webpack_require__(79625);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/bitHelpers.ts
var bitHelpers = __webpack_require__(11966);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/PurchasePage/Preview/Payment/BitPage.tsx













var BitPage = function BitPage() {
  var _usePurchaseContext = (0,PurchaseContext/* usePurchaseContext */.AX)(),
      setPurchaseData = _usePurchaseContext.setPurchaseData,
      setSelectedGiftCard = _usePurchaseContext.setSelectedGiftCard,
      setBlessingMode = _usePurchaseContext.setBlessingMode,
      setGiftCardLoadAmount = _usePurchaseContext.setGiftCardLoadAmount,
      setOrderId = _usePurchaseContext.setOrderId,
      setOrderRecipientGuid = _usePurchaseContext.setOrderRecipientGuid;

  var _usePaymentContext = (0,PaymentContext/* usePaymentContext */.JL)(),
      setPaymentSteps = _usePaymentContext.setPaymentSteps;

  var router = (0,next_router.useRouter)();
  var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
  (0,react.useEffect)(function () {
    if (!isDesktop) {
      var hasParams = Object.keys(router.query).length > 0;

      if (hasParams) {
        var _router$query, _router$query$payment, _router$query2, _router$query2$orderg;

        var paymentinitiaionid = (_router$query = router.query) === null || _router$query === void 0 ? void 0 : (_router$query$payment = _router$query.paymentinitiaionid) === null || _router$query$payment === void 0 ? void 0 : _router$query$payment.toString();
        var orderguid = (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : (_router$query2$orderg = _router$query2.orderguid) === null || _router$query2$orderg === void 0 ? void 0 : _router$query2$orderg.toString();

        if (!paymentinitiaionid || !orderguid) {
          router.push("/");
          return;
        }

        updateContextData(orderguid);

        var postBitPayment = /*#__PURE__*/function () {
          var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
            var _yield$postPaymentPay, data;

            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (0,api.postPaymentPaymentDoneBit)({
                      paymentInitiationId: paymentinitiaionid
                    });

                  case 2:
                    _yield$postPaymentPay = _context.sent;
                    data = _yield$postPaymentPay.data;

                    if (data.body.success) {
                      router.push("/payment");
                      setPaymentSteps(payment.PaymentSteps.SUCCESS);
                      localStorage.removeItem("orderGuid");
                    } else {
                      router.push("/payment");
                      localStorage.removeItem("orderGuid");
                    }

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function postBitPayment() {
            return _ref.apply(this, arguments);
          };
        }();

        postBitPayment();
      }
    }
  }, [router]);

  var updateContextData = function updateContextData(id) {
    var data = (0,bitHelpers/* getPaymentDataFromLocalStorage */.GK)(id);

    if (!data) {
      return;
    }

    setPurchaseData(data.purchaseData);
    setSelectedGiftCard(data.selectedGiftCard);
    setBlessingMode(data.blessingMode);
    setGiftCardLoadAmount(data.giftCardLoadAmount);
    setOrderId(data.orderId);
    setOrderRecipientGuid(data.orderRecipientGuid);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {});
};

/* harmony default export */ var Payment_BitPage = (BitPage);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/pages/payment/bit.tsx




var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "bit__StyledWrapper",
  componentId: "sc-dpcxfz-0"
})(["padding-right:60px;margin-top:80px;padding-left:120px;padding-bottom:100px;", "{margin-top:66px;padding-left:16px;padding-right:16px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var Bit = function Bit() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Payment_BitPage, {})
  });
};

/* harmony default export */ var bit = (Bit);

/***/ }),

/***/ 35194:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment/bit",
      function () {
        return __webpack_require__(64489);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,2726,3450,2198,2663,3818,4055,1456,9904,8643,2563,3050,9774,2888,179], function() { return __webpack_exec__(35194); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);